// import { SlideBackground, SlideTransition } from "../../../types/Slides";
export function handleObjProps(root, obj, slide) {
    const props = Object.keys(obj);
    for (let i = 0, l = props.length; i < l; i++) {
        const prop = props[i];
        const value = String(obj[prop]);
        if (value) {
            slide.setAttribute(`data-${root}${prop !== root ? "-" + prop : ""}`, value);
        }
    }
}
